// extracted by css-extract-rspack-plugin
export default {"caption":"V0dTzRFsRR82Tm7w","icon":"Bm4wtEG2sshRUbrS","link":"jvDCkw8znL8vynK0"};